import axios from 'axios';
import * as Constants from "../common/constants";
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { OfferFilterSettingsModel } from "../models/offer/offerFilterSettingsModel";

class OffersService {
    authService = new AuthService();
    axiosInstance = axios.create({
        baseURL: `${Constants.apiUrl}/`,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache'
        }
    })

    getAllOffers(from: number, numberOfRows: number, settings: OfferFilterSettingsModel) {
        return this.axiosInstance({
            url: `offers/getAllForMobile/${from}/${numberOfRows}`,
            method: 'post', headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(settings)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }
}

export default OffersService;
